import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Compõe classes condicionais resolvendo conflitos do Tailwind.
 * Padrão do ecossistema (PMC, SGI, SYS) — usar SEMPRE em vez de template string.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/**
 * Iniciais para avatar. Uma letra quando há um nome só, duas quando há mais —
 * primeira e última palavra, ignorando partículas ("de", "da", "dos"...).
 */
export function getInitials(name: string): string {
  const parts = name
    .trim()
    .split(/\s+/)
    .filter((part) => part.length > 0 && !/^(d[aeio]s?|e)$/i.test(part))

  if (parts.length === 0) return '?'

  const first = parts[0]
  if (parts.length === 1) return (first?.[0] ?? '?').toUpperCase()

  const last = parts[parts.length - 1]
  return `${first?.[0] ?? ''}${last?.[0] ?? ''}`.toUpperCase()
}
